/* eslint-disable */
export default {
  logging: 'Connexion…',
  logCall: 'Journal des appels',
  editLog: 'Modifier le journal',
  select: 'Sélect. un enreg.',
  OnHold: 'En attente',
  Ringing: 'Sonnerie en cours',
  CallConnected: 'Appel connecté',
  unknownUser: 'Utilisateur inconnu',
  unknownNumber: 'Anonyme',
  unavailable: 'Non disponible',
  viewDetails: 'Afficher les renseignements',
  conferenceCall: 'Téléconférence',
  callerId: 'ID de l’appelant',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"callerId"@#@ @source: @#@"Caller ID"@#@
